import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    addWorkspaceName: string;
    editAvatar: string;
    workspaceName: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Placeholder text for workspace name input */
            addWorkspaceName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DetailsInput.addWorkspaceName?c=ee3zvg4pl9r9", defaultMessage: "Add workspace name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the avatar editor action */
            editAvatar: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DetailsInput.editAvatar?c=15xb4wbq3buf6", defaultMessage: "Edit workspace avatar" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the workspace name field */
            workspaceName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DetailsInput.workspaceName?c=2ew295eir43ng", defaultMessage: "Workspace name" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
